import React, { useEffect, useRef, useState } from 'react'
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Select,
  message,
  DatePicker,
  Card,
  Popconfirm,
  Checkbox,
  Menu,
  Space,
  Radio,
  Modal,
  Divider,
  Tooltip,
  Descriptions,
  Table,
  Tag,
  Alert,
  Dropdown,
} from 'antd'
import {
  ProjectService,
  InformfixService,
  TechnicainService,
  JobGroupService,
  JobService,
} from '../../../services'
import {
  Moment,
  disabledDateTime,
  openNotificationWithIcon,
} from '../../../helpers'
import './style.scss'
import {
  ReloadOutlined,
  DeleteFilled,
  EditFilled,
  PlusOutlined,
  CheckSquareFilled,
  QuestionCircleOutlined,
  TrophyOutlined,
  LoadingOutlined,
  UserOutlined,
  DeleteOutlined,
  MinusCircleOutlined,
  SaveOutlined,
  EditOutlined,
  SendOutlined,
} from '@ant-design/icons'
import { inject, observer } from 'mobx-react'
import { JobDateTime } from '../../job/JobDateTime'
import { JobStatus } from '../../job/JobStatus'
import { InformfixDateTime } from '../InformfixDateTime'
import { has } from 'lodash'
import { Config } from '../../../config'
import { useForm } from 'antd/lib/form/Form'
import DateTimePicker from '../../_shared/datetime'
import { JobTechnichian } from '../../job/JobTechnichian'
import ButtonGroup from 'antd/lib/button/button-group'
import TableResponsiveOK from '../../_shared/responsive-table'
const { Option } = Select

const defaultJobGroup = -1

@inject('informStore')
@observer
class AssignJob extends React.Component {
  state = {
    loading: false,
    homes: [],
    projects: [],
    loading: false,
    home: {},
    project: {},
    count: 2,
    technicians: [],
    techniciansTemp: [],
    selectedResponsible: [],
    selectedTechnician: [],
    jobgroups: [],
    jobs: [],
    listJobStatus: [],
    visibleFormAdd: false,
    visibleFormEdit: false,
    visibleModalCloseJob: false,
    job: {},
    loadingDelete: false,
  }
  constructor() {
    super()
  }
  controller = new AbortController()
  formRef = React.createRef()

  /**
   * แสดง/ซ่อน Modal เพิ่มคิวงาน
   */
  setVisibleFormAdd = (value) => {
    this.setState({
      visibleFormAdd: value,
    })
  }
  /**
   * แสดง/ซ่อน Modal แก้ไขงานซ่อม
   */
  setVisibleFormEdit = (value) => {
    this.setState({
      visibleFormEdit: value,
    })
  }
  /**
   * แสดง/ซ่อน Modal การปิดงานซ่อม
   */
  setVisibleFormCloseJob = (value) => {
    this.setState({
      visibleModalCloseJob: value,
    })
  }
  /**
   * เพิ่มคิวงานซ่อม
   */
  onCreateJob = (values) => {
    if (values) {
      JobService.create(values)
        .then((res) => {
          this.setVisibleFormAdd(false)
          openNotificationWithIcon('success', res.data.message)
          this.reloadJobs()
        })
        .catch((error) => {
          if (error.response) {
            openNotificationWithIcon('error', error.response.statusText)
          }
        })
    }
  }
  /**
   * แก้ไขคิวงานซ่อม
   */
  onUpdateJob = (values) => {
    if (values) {
      JobService.update(this.state.job.id, values)
        .then((res) => {
          this.setVisibleFormEdit(false)
          openNotificationWithIcon('success', res.data.message)
          this.setState({
            job: res.data.data,
          })
          this.reloadJobs()
        })
        .catch((error) => {
          openNotificationWithIcon('error', error.response.statusText)
        })
    }
  }

  componentDidMount() {
    this.getJobs()
    this.getTechnicians()
    this.getJobGroup()
    this.getJobStatus()
  }

  reloadJobs = () => {
    this.getJobs()
    this.reloadInformFix(this.props.informStore.getItem.id)
  }

  reloadInformFix = (id) => {
    InformfixService.view(id).then((rs) => {
      this.props.informStore.setItem(rs.data.data)
    })
  }

  getProjects = () => {
    this.setState({ loadingProject: true })
    this.setState({ homes: [] })
    ProjectService.all()
      .then((rs) => {
        if (rs) {
          let data = []
          rs.data['data'].map((item) => {
            let homes = []
            if (item.homeCustomer) {
              item.homeCustomer.map((home) => {
                homes.push({
                  value: home.id,
                  label:
                    'แปลง ' +
                    home.plan_no +
                    (home.home_no ? ' (เลขที่ ' + home.home_no + ')' : ''),
                })
              })
            }
            data.push({
              value: item.id,
              label: item.name,
              children: homes,
            })
          })
          this.setState({ loadingProject: false })
          this.setState({ projects: data, loading: false })
        }
      })
      .catch((err) => this.setState({ loadingHome: false }))
  }

  getHomeByProjectId = (projectId) => {
    this.setState({ disabledSelectHome: true })
    ProjectService.getHomesByProject(projectId)
      .then((rs) => {
        if (rs) {
          this.setState({ disabledSelectHome: false })
          this.setState({ homes: rs.data['data'], loading: false })
        }
      })
      .catch((err) => this.setState({ loadingHome: false }))
  }

  /**
   * หมวดหมู่งานแจ้งซ่อม
   */

  getJobGroup = () => {
    this.setState({ jobgroups: [] })
    JobGroupService.all().then((rs) => {
      let data = []
      if (rs) {
        let data = []
        const items = rs.data['data']
        if (items) {
          items.map((item, index) => {
            data.push({
              value: item.id,
              text: item.name,
            })
          })
        }
        this.setState({ jobgroups: data })
      }
    })
  }
  /**
  ตารางงานทั้งหมด
 */
  getJobs = () => {
    this.setState({ jobs: [], loading: true })
    InformfixService.getJobs(this.props.informfixId).then((rs) => {
      if (rs) {
        const job = rs.data['data']
        this.setState({
          jobs: job,
          loading: false,
        })
      }
    })
  }

  getTechnicians = () => {
    this.setState({ technicians: [] })
    TechnicainService.all()
      .then((rs) => {
        if (rs) {
          let data = []
          const items = rs.data['data']
          if (items) {
            items.map((item, index) => {
              data.push({
                value: item.id,
                text:
                  item.firstname +
                  ' ' +
                  item.lastname +
                  (item.nickname ? ' (' + item.nickname + ')' : null),
              })
            })
          }
          this.setState({ technicians: data })
        }
      })
      .catch((err) => {})
  }

  /**
   * ข้อมูลสถานะ
   */
  getJobStatus() {
    JobService.getJobStatus().then((rs) => {
      if (rs) {
        const data = rs.data['data']
        this.setState({ listJobStatus: data })
      }
    })
  }
  /**
   * เมื่อเปลี่ยนโครงการใน DropDown
   */
  onChangeProject = (value) => {
    this.setState({ homes: [] })
    if (value) {
      this.setState({ homes: [], disabledSelectHome: true })
      this.getHomeByProjectId(value)
    }
  }

  resetForm() {
    this.formRef.current.resetFields()
  }

  cancelJobItem = (id) => {
    JobService.cancel(id).then(() => {})
  }

  canUpdateJob = () => {
    const work_status = this.props.inform ? this.props.inform.work_status : null
    if (
      work_status == Config.informfix.status.OPEN.value ||
      work_status == Config.informfix.status.WAIT.value
    ) {
      return true
    }
    return false
  }

  delelteJobItem = (id) => {
    JobService.delete(id)
      .then(() => {
        this.setState({
          loadingDelete: false,
        })
      })
      .catch((err) => {
        this.setState({
          loadingDelete: false,
        })
      })
  }
  /**
   * ลบคิวงาน
   */
  removeRow = (k) => {
    if (this.state.jobs.length === 0) {
      return
    }
    this.setState({
      loadingDelete: true,
    })
    let jobs = this.state.jobs
    const itemId = jobs[k].id
    console.log('itemId', itemId)
    if (itemId > 0) {
      this.delelteJobItem(itemId)
    }
    jobs.splice(k, 1)
    this.setState({
      jobs: jobs,
    })
    openNotificationWithIcon('success', 'ลบคิวงานเรียบร้อย')
    this.reloadJobs()
  }
  /**
   * แก้ไขเวลาเริ่มต้น
   */
  updateStartTime = (job, value) => {
    let form = job
    if (value && value.isValid()) {
      form.start_time = value.utc(7).format('YYYY-MM-DD HH:mm')
    } else {
      form.start_time = '0000-00-00 00:00'
    }
    JobService.updateStarttime(job.id, { time: form.start_time })
      .then((rs) => {
        if (rs) {
          console.log('rs', rs)
          message.success(rs.data.message)
        }
      })
      .catch((err) => {
        if (err.response) {
          const text = err.response.data.message
          message.error(text)
        }
      })
  }

  /**
   * แก้ไขผู้รับผิดชอบงาน
   */
  onChangeResponsible = (job, value) => {
    console.log('value', value)
    JobService.updateResponsible(job.id, { responsible_id: value })
      .then((rs) => {
        if (rs) {
          console.log('rs', rs)
          message.success(rs.data.message)
        }
      })
      .catch((err) => {
        if (err.response) {
          const text = err.response.data.message
          message.error(text)
        }
      })
  }

  /**
   * แก้ไขเวลาสิ้นสุดนัดหมาย
   */
  updateEndTime = (job, value) => {
    let form = job
    if (value && value.isValid()) {
      form.end_time = value.utc(7).format('YYYY-MM-DD HH:mm')
    } else {
      form.end_time = '0000-00-00 00:00'
    }
    JobService.updateEndtime(job.id, { time: form.end_time })
      .then((rs) => {
        if (rs) {
          console.log('rs', rs)
          message.success(rs.data.message)
        }
      })
      .catch((err) => {
        if (err.response) {
          const text = err.response.data.message
          message.error(text)
        }
      })
  }
  /**
   * แก้ไขช่างอื่นๆ /ผู้รับเหมาอื่นๆ
   */
  updateTechnicianOther = (e, job) => {
    let form = job
    const value = e.target.value
    JobService.updateTechnicianOther(job.id, {
      technician_name_other: value,
    })
      .then((rs) => {
        if (rs) {
          console.log('rs', rs)
          message.success(rs.data.message)
        }
      })
      .catch((err) => {
        if (err.response) {
          const text = err.response.data.message
          message.error(text)
        }
      })
  }
  /**
   * มอบหมายงานให้ช่าง
   */
  onAssignTechnichian = (job, technician) => {
    console.log('t', technician)
    JobService.assignTechnichian(job.id, { technicians: technician })
      .then((rs) => {
        if (rs) {
          console.log('rs', rs)
          message.success(rs.data.message)
        }
      })
      .catch((err) => {
        console.log('error', err)
        // if (err.response) {
        //   const message = err.response.data.message
        //   message.error(message)
        // }
      })
  }
  /**
   * มอบหมายงานให้ช่าง
   */
  reConfirmAssign = (record) => {
    const inform = this.props.informStore.getItem
    const jobs = this.state.jobs
    JobService.reConfirmAssign(record.id)
      .then((rs) => {
        if (rs) {
          console.log('rs', rs)
          const _job = rs.data.data
          console.log('job', _job)
          jobs.map((job, key) => {
            if (job.id == record.id) {
              jobs[key].postpone_mark = _job.postpone_mark
              jobs[key].postpone_remark = _job.postpone_remark
            }
          })
          this.setState({
            jobs: jobs,
          })
          this.props.informStore.setJobItems(jobs)
          message.success(rs.data.message)
        }
      })
      .catch((err) => {
        if (err.response) {
          const message = err.response.data.message
          message.error(message)
        }
      })
  }

  closeJob = (item) => {
    console.log('dd', item)
    const inform = this.props.informStore.getItem
    const jobs = [...this.state.jobs]
    JobService.close(item.id)
      .then((rs) => {
        const _inform = rs.data.data.informfix
        const _job = rs.data.data.job
        jobs.map((job, key) => {
          console.log('item', _job)
          if (job.id == item.id) {
            jobs[key] = _job
          }
        })
        inform.work_status = _inform.work_status
        inform.workStatusName = _inform.workStatusName
        this.props.informStore.setItem(inform)
        this.setState({
          jobs: jobs,
        })
        this.setVisibleFormCloseJob(true)
      })
      .catch((err) => {
        if (err.response) {
          const message = err.response.data.message
          message.error(message)
        }
      })
  }

  showTechnicaianName = (technicians) => {
    if (technicians && technicians.length > 0) {
      const item = technicians[0]
      const nickname = item.technician.nickname
        ? '(' + item.technician.nickname + ')'
        : null
      const fullname =
        item.technician.firstname + ' ' + item.technician.lastname
      return (
        <Tag>
          <UserOutlined /> {fullname}
        </Tag>
      )
    } else {
      return <Tag>ไม่ได้ระบุ</Tag>
    }
  }

  showDateTime = (datetime) => {
    return datetime && Moment(datetime).isValid()
      ? Moment(datetime).format('lll')
      : null
  }

  onSubmitJob = (values) => {
    console.log('values', values)
  }

  render() {
    const { loading, listJobStatus, jobs, loadingDelete } = this.state

    const { modalOptions } = this.props
    const inform = this.props.informStore.getItem
    const formLayout = 'horizontal'

    const jobItems = {
      if(jobs) {
        return jobs
      },
    }

    const columnTable = [
      {
        title: 'ID',
        dataIndex: 'id',
        width: 60,
      },
      {
        title: 'ตั้งแต่เวลา',
        dataIndex: 'start_time',
        width: 110,
        render: (start_time, item) => {
          return (
            <React.Fragment>
              <JobDateTime
                datetime={item.start_time}
                jobStatus={item.status_id}
              />
            </React.Fragment>
          )
        },
      },
      {
        title: 'ถึงเวลา',
        dataIndex: 'end_time',
        width: 110,
        render: (end_time, item) => {
          return (
            <React.Fragment>
              <JobDateTime
                datetime={item.end_time}
                jobStatus={item.status_id}
              />
            </React.Fragment>
          )
        },
      },
      {
        title: 'งาน',
        dataIndex: 'list',
        render: (list, item) => {
          return (
            <React.Fragment>
              <strong>{item.list}</strong>
              {item.group ? '<div>[' + item.group.name + ']</div>' : null}
              <p>
                <small>{item.description}</small>
              </p>
            </React.Fragment>
          )
        },
      },
      // {
      //   title: 'Amount',
      //   dataIndex: 'amount',
      //   width: 100,
      //   sorter: (a, b) => a.amount - b.amount,
      // },
      // {
      //   title: 'หมวดหมู่',
      //   dataIndex: 'group.name',
      //   width: 120,
      //   render: (group, item) => {
      //     return (
      //       <React.Fragment>
      //         <Tag>{item.group ? item.group.name : null}</Tag>
      //       </React.Fragment>
      //     )
      //   },
      // },
      // {
      //   title: 'ช่าง',
      //   dataIndex: '',
      //   width: 80,
      //   render: (group, item) => {
      //     //return  (<JobTechnichian technicians={item.technicians}/>)
      //     return this.showTechnicaianName(item.technicians)
      //   },
      // },
      // {
      //   title: 'สถานะ',
      //   dataIndex: 'jobStatusName',
      //   render: (job_status, item) => {
      //     return (
      //       <React.Fragment>
      //         <JobStatus name={item.jobStatusName} statusId={item.job_status} />
      //         <div style={{ marin: 3, textAlign: 'center' }}>
      //           <JobDueDate data={item} />
      //         </div>
      //       </React.Fragment>
      //     )
      //   },
      // },
      {
        title: 'Action',
        key: 'action',
        width: '120px',
        render: (action, record) => (
          <React.Fragment>
            {/* แสดงปุ่มแก้ไขและลบเฉพาะสถานะ [รอดำเนินการ] [กำลังดำเนินการ] */}
            {has([1, 2], record.job_status) ? (
              <React.Fragment>
                <Tooltip title="ลบ" key={'tooltiptitle' + record.id}>
                  {record.id > 0 ? (
                    <Popconfirm
                      okText="ใช่, ลบเลย"
                      cancelText="ไม่"
                      key={'pcf' + record.id}
                      title={
                        'ต้องการลบงาน หมายเลข ' + record.id + ' ใช่หรือไม่ ？'
                      }
                      onConfirm={() =>
                        this.removeRow(this.state.jobs.indexOf(record))
                      }
                      placement="left"
                    >
                      <Button
                        shape="circle"
                        size="small"
                        type="danger"
                        icon={<DeleteFilled />}
                        title="ลบ"
                      ></Button>
                    </Popconfirm>
                  ) : (
                    <Button
                      shape="circle"
                      size="small"
                      type="danger"
                      icon={<DeleteFilled />}
                      title="ลบ"
                    ></Button>
                  )}
                </Tooltip>
                <Space /> <Space />
                <Tooltip title="แก้ไข">
                  <Button
                    shape="circle"
                    size="small"
                    type="light"
                    icon={<EditFilled />}
                    title="แก้ไข"
                    onClick={() => {
                      this.setState({
                        job: record,
                      })
                      this.props.informStore.setJob(record)
                      this.setVisibleFormEdit(true)
                    }}
                  ></Button>
                </Tooltip>
              </React.Fragment>
            ) : null}
            {/* แสดงปุ่มปิดงานถ้าใบแจ้งซ่อมอยู่ในสถานะ [กำลังดำเนินการ] และมีคิวงานมากกว่า 0 รายการ*/}
            {this.props.informStore.getItem.work_status ==
              Config.informfix.status.PROCEED.value &&
            (record.job_status == 1 || record.job_status == 2) ? (
              <Tooltip title="ปิดงาน (เปลี่ยนสถานะเป็นเสร็จสิ้น)">
                <Popconfirm
                  title={
                    'ยืนยันงานเสร็จสิ้น หมายเลข ' + record.id + ' ใช่หรือไม่ ？'
                  }
                  icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                  okText="งานเสร็จแล้ว"
                  cancelText="ยกเลิก"
                  placement="left"
                  onConfirm={() => this.closeJob(record)}
                >
                  <Button
                    shape="circle"
                    size="small"
                    type="light"
                    icon={<TrophyOutlined />}
                  ></Button>
                </Popconfirm>
              </Tooltip>
            ) : null}
          </React.Fragment>
        ),
      },
    ]

    const CanEditJob = (job) => {
      // return (
      //   job.job_status == Config.job.status.OPEN.value ||
      //   job.job_status == Config.job.status.POSTPONE.value ||
      //   job.job_status == Config.job.status.PROCEED.value
      // )
      return true
    }

    const layout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    }
    const tailLayout = {
      wrapperCol: { offset: 8, span: 16 },
    }

    return (
      <React.Fragment>
        <div id="assign-job">
          {this.props.informStore.getItem ? (
            <React.Fragment>
              <Descriptions
                title={inform.description}
                columns={{ xs: 1, sm: 2, md: 2, xl: 2 }}
                style={{
                  marginBottom: 5,
                }}
                bordered
              >
                <Descriptions.Item label="เลขที่ใบแจ้งงาน">
                  {inform.id}
                </Descriptions.Item>
                <Descriptions.Item label="วันที่แจ้ง">
                  <InformfixDateTime datetime={inform.inform_date} />
                </Descriptions.Item>
                <Descriptions.Item label="ผู้แจ้ง">
                  {inform ? inform.informer : null}
                </Descriptions.Item>
                <Descriptions.Item label="สถานะที่">
                  {inform.project ? inform.project.name : null}
                </Descriptions.Item>

                <Descriptions.Item label="บ้านเลขที่">
                  {inform.home ? inform.home.home_no : null}
                  {inform.home ? <Tag>{inform.home.plan_no}</Tag> : null}
                </Descriptions.Item>
                <Descriptions.Item label="เบอร์ติดต่อกลับ">
                  {inform.contact_phone}
                </Descriptions.Item>
                <Descriptions.Item label="เวลาที่สะดวกใหัติดต่อ">
                  {inform.contact_time}
                </Descriptions.Item>
              </Descriptions>
              {/* {inform.description ? (
                <p>
                  <strong>{inform.subject} </strong>
                  <br />
                  {inform.description}
                </p>
              ) : null} */}

              {loading ? (
                <div align="center">
                  <Alert message="กำลังโหลดข้อมูลงาน........................"></Alert>
                </div>
              ) : (
                <>
                  <TableResponsiveOK
                    colums={{ id: 'ID', description: 'description' }}
                    rows={this.state.jobs}
                  />
                  <table
                    className="ant-table ant-table-bordered"
                    border="1"
                    cellPadding="5"
                    style={{ width: '100%' }}
                  >
                    <thead>
                      <tr>
                        <td>ID</td>
                        <td>หมวดหมู่</td>
                        <td>ตั้งแต่เวลา</td>
                        <td>ถึงเวลา</td>
                        <td>รายละเอียด</td>
                        <td>ผู้รับผิดชอบ</td>
                        <td>ช่าง</td>
                        <td>สถานะงาน</td>
                        <td></td>
                      </tr>
                    </thead>
                    {this.state.jobs.length > 0 ? (
                      this.state.jobs.map((item, itemKey) => (
                        <>
                          <tbody key={`tb${itemKey}`}>
                            <tr key={`trjob${itemKey}`}>
                              <td>{item.id}</td>
                              <td>{item.group ? item.group.name : null}</td>
                              <td>
                                <JobDateTime
                                  datetime={item.start_time}
                                  key={`start-time-${itemKey}`}
                                />
                              </td>
                              <td>
                                <JobDateTime
                                  datetime={item.end_time}
                                  key={`end-time-${itemKey}`}
                                />
                              </td>
                              <td>{item.description}</td>
                              <td>{item.responsible_name}</td>
                              <td>
                                {' '}
                                <JobTechnichian
                                  technicians={item.technicians}
                                  technicianOther={item.technician_name_other}
                                  key={`tc-${itemKey}`}
                                />
                              </td>
                              <td>{item.jobStatusName}</td>
                              <td align="left">
                                <Button
                                  type="default"
                                  icon={<EditOutlined />}
                                  onClick={() => {
                                    this.setState({
                                      job: item,
                                    })
                                    this.setVisibleFormEdit(true)
                                  }}
                                  size="small"
                                  style={{ textAlign: 'left' }}
                                >
                                  แก้ไข
                                </Button>
                                <Space /> <Space />
                                <Popconfirm
                                  title="ต้องการลบรายการนี้ใช่หรือไม่ ?"
                                  okButtonProp={{ loading: loadingDelete }}
                                  onConfirm={() => this.removeRow(itemKey)}
                                >
                                  <Button
                                    size="small"
                                    icon={<DeleteOutlined />}
                                    style={{ textAlign: 'left' }}
                                    danger
                                  >
                                    ลบ
                                  </Button>
                                </Popconfirm>
                                {/* <div>
                                  <Dropdown.Button
                                    size="small"
                                    overlay={
                                      <>
                                        <Menu
                                          onClick={(e) => {
                                            console.log('click', e.key)
                                          }}
                                        >
                                          <Menu.Item
                                            key="1"
                                            onClick={() => {
                                              this.setState({
                                                job: item,
                                              })
                                              this.setVisibleFormEdit(true)
                                            }}
                                          >
                                            แก้ไข
                                          </Menu.Item>

                                          <Menu.Item key="2">
                                            <Popconfirm
                                              title="ต้องการลบรายการนี้ใช่หรือไม่ ?"
                                              okButtonProp={{
                                                loading: loadingDelete,
                                              }}
                                              onConfirm={() =>
                                                this.removeRow(itemKey)
                                              }
                                            >
                                              ลบ
                                            </Popconfirm>
                                          </Menu.Item>

                                          <Menu.Item key="3">
                                            ยืนยันคิวงาน
                                          </Menu.Item>
                                        </Menu>
                                      </>
                                    }
                                  >
                                    Actions
                                  </Dropdown.Button>
                                </div> */}
                              </td>
                            </tr>
                          </tbody>
                        </>
                      ))
                    ) : (
                      <tbody>
                        <tr>
                          <td colSpan={9}>-ไม่มีข้อมูล-</td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                </>
              )}

              {/* //////////////// รายการงานซ่อม ///////////////////// */}
              {loading ? (
                <div align="center">
                  <LoadingOutlined
                    style={{
                      fontSize: 60,
                      textAlign: 'center',
                      margin: '10 auto',
                    }}
                  />
                </div>
              ) : null}
            </React.Fragment>
          ) : null}
          <Divider />

          {/* ###################### เพิ่มคิวงาน ######################## */}
          {this.state.visibleFormAdd ? (
            <CollectionCreateForm
              visible={this.state.visibleFormAdd}
              onCreate={(values) => this.onCreateJob(values)}
              onCancel={() => {
                this.setVisibleFormAdd(false)
              }}
              informData={inform}
              jobgroups={this.state.jobgroups}
              technicians={this.state.technicians}
              listJobStatus={this.state.listJobStatus}
            />
          ) : null}

          {/* ##################### แก้ไขคิวงาน########################### */}
          {this.state.visibleFormEdit ? (
            <CollectionEditForm
              visible={this.state.visibleFormEdit}
              onUpdate={(values) => this.onUpdateJob(values)}
              onCancel={() => {
                this.setVisibleFormEdit(false)
              }}
              informData={inform}
              job={this.state.job}
              jobgroups={this.state.jobgroups}
              technicians={this.state.technicians}
              listJobStatus={this.state.listJobStatus}
            />
          ) : null}

          <div className="job-action">
            <Space />
            <Button
              shape="round"
              type="success"
              icon={<ReloadOutlined />}
              onClick={() => this.reloadJobs()}
            >
              รีโหลดงาน
            </Button>
            <Space /> <Space />
            <Button
              shape="round"
              onClick={() => {
                this.setVisibleFormAdd(true)
              }}
              icon={<PlusOutlined />}
            >
              เพิ่มคิวงาน
            </Button>
            <Space /> <Space />
            {/* {inform.work_status} / {Config.informfix.status.OPEN.value} */}
            {inform.work_status == Config.informfix.status.OPEN.value ? (
              <Popconfirm title="ยืนยันส่งคิวงาน ? [เพื่อส่งคิวงานไปยืนยันกับลูกค้าต่อไป]">
                <Button
                  shape="round"
                  onClick={() => {}}
                  icon={<SendOutlined />}
                >
                  ส่งต่อไปยืนยันคิวงาน
                </Button>
              </Popconfirm>
            ) : null}
          </div>
        </div>
      </React.Fragment>
    )
  }
}
export default AssignJob

/********************************************************
 * แบบฟอร์มเพิ่มข้อมูล
 ********************************************************/

const CollectionCreateForm = ({
  visible,
  onCreate,
  onCancel,
  informData,
  jobgroups,
  technicians,
  listJobStatus,
}) => {
  const [form] = Form.useForm()
  const formLayout = 'horizontal'

  const formItemLayout =
    formLayout === 'horizontal'
      ? {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
            md: { span: 6 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 18 },
            md: { span: 18 },
          },
        }
      : null
  const buttonItemLayout =
    formLayout === 'horizontal'
      ? {
          wrapperCol: {
            xs: { span: 24, offset: 0 },
            sm: { span: 18, offset: 6 },
            md: { span: 18, offset: 6 },
          },
        }
      : null

  return (
    <Modal
      open={visible}
      title="เพิ่มคิวงานซ่อม"
      okText="Create"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            const additionData = {
              project_id: informData.project_id,
              home_id: informData.home_id,
              inform_fix_id: informData.id,
            }
            if (values.start_time) {
              values.start_time = Moment(values.start_time).utc(7)
            }
            if (values.end_time) {
              values.end_time = Moment(values.end_time).utc(7)
            }
            values = { ...values, ...additionData }
            // form.resetFields()
            onCreate(values)
            console.log('press save', values)
          })
          .catch((info) => {
            console.log('Validate Failed:', info)
          })
      }}
    >
      <Form
        form={form}
        layout={formLayout}
        initialValues={{
          inform_fix_id: informData ? informData.id : null,
          project_id: informData ? informData.project_id : null,
          home_id: informData ? informData.home_id : null,
          id: null,
          title: null,
          description: null,
          start_time: null,
          end_time: null,
          job_status: 1, // ค่าเริ่มต้นตั้งไว้เป็นรอคำเนินการ
          technicians: [],
          responsible_id: null,
          responsible_name: null,
        }}
      >
        <Form.Item
          {...formItemLayout}
          label="รายการ"
          name="title"
          rules={[{ required: true, message: 'รายการ' }]}
        >
          <Input
            placeholder="หัวข้อ"
            style={{
              width: '100%',
            }}
            type="text"
          />
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="รายละเอียด"
          name="description"
          rules={[{ required: false, message: 'รายละเอียด' }]}
        >
          <Input.TextArea
            placeholder="รายละเอียด"
            style={{
              width: '100%',
            }}
            rows={5}
          />
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="หมวดหมู่"
          name="group_id"
          rules={[{ required: true, message: 'หมวดหมู่' }]}
        >
          <Select
            allowClear
            placeholder="--เลือกหมวดหมู่--"
            showSearch
            filterOption={false}
          >
            {jobgroups.map((d) => (
              <Option key={d.value} value={d.value}>
                {d.text}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="ตั้งแต่"
          {...formItemLayout}
          name="start_time"
          rules={[{ required: true, message: 'เลือกวันที่และเวลา' }]}
        >
          <DatePicker
            placeholder="ตั้งแต่เวลา"
            disabledTime={disabledDateTime}
            showTime={{
              defaultValue: Moment('09:00:00', 'HH:mm:ss'),
            }}
            showToday
            format="DD/MM/YYYY HH:mm"
            style={{ width: '100%' }}
            now
            // defaultValue={
            //   start_time && Moment(start_time).isValid()
            //     ? Moment(start_time)
            //     : null
            // }
          />
        </Form.Item>

        <Form.Item
          label="ถึงเวลา"
          {...formItemLayout}
          name="end_time"
          rules={[{ required: true, message: 'เลือกวันที่และเวลา' }]}
        >
          <DatePicker
            placeholder="ถึงเวลา"
            disabledTime={disabledDateTime}
            showTime={{
              defaultValue: Moment('09:00:00', 'HH:mm:ss'),
            }}
            ShowToday
            format="DD/MM/YYYY HH:mm"
            style={{ width: '100%' }}
            // defaultValue={
            //   end_time && Moment(end_time).isValid() ? Moment(end_time) : null
            // }
          />
        </Form.Item>
        <Form.Item
          label="ผู้รับผิดชอบ"
          {...formItemLayout}
          name="responsible_id"
          rules={[{ required: false, message: 'ผู้รับผิดชอบ' }]}
        >
          <Select
            placeholder="--ผู้รับผิดชอบ--"
            showSearch
            allowClear
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {technicians
              ? technicians.map((d) => (
                  <Option key={d.value} value={d.value}>
                    {d.text}
                  </Option>
                ))
              : null}
          </Select>
        </Form.Item>
        <Form.Item
          label="ช่าง"
          {...formItemLayout}
          name="technician"
          rules={[{ required: false, message: 'เลือกช่าง' }]}
        >
          <Select
            mode="multiple"
            placeholder="--เลือกช่าง--"
            showSearch
            allowClear
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {technicians
              ? technicians.map((d) => (
                  <Option key={d.value} value={d.value}>
                    {d.text}
                  </Option>
                ))
              : null}
          </Select>
        </Form.Item>
        <Form.Item
          {...formItemLayout}
          label="ช่าง/ผู้รับเหมา (อื่นๆ)"
          name="technician_name_other"
          rules={[{ required: false, message: 'ช่าง/ผู้รับเหมา (อื่นๆ)' }]}
        >
          <Input
            placeholder="ช่าง/ผู้รับเหมา (อื่นๆ)"
            style={{
              width: '100%',
            }}
            type="text"
          />
        </Form.Item>
        <Form.Item
          label="สถานะงาน"
          {...formItemLayout}
          name="job_status"
          rules={[{ required: true, message: 'เลือกสถานะ' }]}
        >
          <Select
            autoComplete="off"
            placeholder="--เลือกสถานะ--"
            filterOption={false}
            optionLabelProp="label"
          >
            {listJobStatus
              ? listJobStatus.map((d) => (
                  <Option key={d.value} value={d.value} label={d.text}>
                    {d.text}
                  </Option>
                ))
              : null}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  )
}

/********************************************************
 * แบบฟอร์มแก้ไขข้อมูล
 ********************************************************/
const CollectionEditForm = ({
  visible,
  onUpdate,
  onCancel,
  jobgroups,
  technicians,
  listJobStatus,
  informData,
  job,
}) => {
  const [form] = Form.useForm()
  const formLayout = 'horizontal'
  const formEditRef = useRef()
  const [data, setData] = useState({})

  const formItemLayout =
    formLayout === 'horizontal'
      ? {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 6 },
            md: { span: 6 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 18 },
            md: { span: 18 },
          },
        }
      : null
  const buttonItemLayout =
    formLayout === 'horizontal'
      ? {
          wrapperCol: {
            xs: { span: 24, offset: 0 },
            sm: { span: 18, offset: 6 },
            md: { span: 18, offset: 6 },
          },
        }
      : null

  useEffect(() => {
    console.log('open edit job', job)
    setData(job)
  }, [])

  const currentSelectedTechnician = (job) => {
    let data = []
    if (job.technicians) {
      job.technicians.map((item) => {
        data.push(item.technician_id)
      })
      return data
    }
    return data
  }

  return (
    <Modal
      visible={visible}
      title="แก้ไขคิวงานซ่อม"
      okText="Update"
      cancelText="Cancel"
      onCancel={() => {
        form.resetFields()
        onCancel()
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            const additionData = {
              project_id: informData.project_id,
              home_id: informData.home_id,
              inform_fix_id: informData.id,
            }
            if (values.start_time) {
              values.start_time = Moment(values.start_time).utc(7)
            }
            if (values.end_time) {
              values.end_time = Moment(values.end_time).utc(7)
            }
            values = { ...values, ...additionData }
            console.log('press update', values)
            form.resetFields()
            onUpdate(values)
          })
          .catch((info) => {
            console.log('Validate Failed:', info)
          })
      }}
    >
      {job ? (
        <Form
          form={form}
          ref={formEditRef}
          layout={formLayout}
          initialValues={{
            inform_fix_id: informData ? informData.id : null,
            project_id: informData ? informData.project_id : null,
            home_id: informData ? informData.home_id : null,
            id: job ? job.id : 0,
            group_id: job ? job.group_id : null,
            title: job ? job.list : '-',
            description: job ? job.description : null,
            technicians:
              job.technicians && job.technicians.length > 0
                ? job.technicians.map((t) => t.technician_id)
                : [],
            start_time:
              job.start_time && Moment(job.start_time).isValid()
                ? Moment(job.start_time).utc(7)
                : null,
            end_time:
              job.end_time && Moment(job.end_time).isValid()
                ? Moment(job.end_time).utc(7)
                : null,
            job_status: job ? job.job_status : null,
            technician_name_other: job ? job.technician_name_other : null,
            // technicians: currentSelectedTechnician(job),
            responsible_id: job.responsible_id ? job.responsible_id : null,
            responsible_name: job.responsible_name
              ? job.responsible_name
              : null,
          }}
        >
          <Form.Item label="ID" {...formItemLayout} required={true} name="id">
            <Input
              placeholder="ID"
              style={{
                width: '100%',
              }}
              type="text"
              readOnly
            />
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="หัวข้อ"
            name="title"
            rules={[{ required: true, message: 'หัวข้อ' }]}
          >
            <Input
              placeholder="หัวข้อ"
              style={{
                width: '100%',
              }}
              type="text"
            />
          </Form.Item>

          <Form.Item
            {...formItemLayout}
            label="รายละเอียด"
            name="description"
            rules={[{ required: false, message: 'รายละเอียด' }]}
          >
            <Input.TextArea
              placeholder="รายละเอียด"
              style={{
                width: '100%',
              }}
              rows={5}
            />
          </Form.Item>

          <Form.Item
            {...formItemLayout}
            label="หมวดหมู่"
            name="group_id"
            rules={[{ required: true, message: 'หมวดหมู่' }]}
          >
            <Select
              allowClear
              placeholder="--เลือกหมวดหมู่--"
              showSearch
              filterOption={(input, option) =>
                option.props.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toString().toLowerCase()) >= 0
              }
            >
              {jobgroups.map((d) => (
                <Option key={d.value} value={d.value}>
                  {d.text}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="ตั้งแต่"
            {...formItemLayout}
            name="start_time"
            rules={[{ required: false, message: 'เลือกวันที่และเวลา' }]}
          >
            <DatePicker
              placeholder="ตั้งแต่เวลา"
              disabledTime={disabledDateTime}
              showTime={{
                defaultValue: Moment('09:00:00', 'HH:mm:ss'),
              }}
              inputReadOnly
              showToday
              format="DD/MM/YYYY HH:mm"
              style={{ width: '100%' }}
              now
            />
          </Form.Item>

          <Form.Item
            label="ถึงเวลา"
            {...formItemLayout}
            name="end_time"
            rules={[{ required: false, message: 'เลือกวันที่และเวลา' }]}
          >
            <DatePicker
              placeholder="ถึงเวลา"
              disabledTime={disabledDateTime}
              showTime={{
                defaultValue: Moment('09:00:00', 'HH:mm:ss'),
              }}
              inputReadOnly
              ShowToday
              format="DD/MM/YYYY HH:mm"
              style={{ width: '100%' }}
            />
          </Form.Item>
          <Form.Item
            label="ผู้รับผิดชอบ"
            {...formItemLayout}
            name="responsible_id"
            rules={[{ required: false, message: 'ผู้รับผิดชอบ' }]}
          >
            <Select
              placeholder="--ผู้รับผิดชอบ--"
              showSearch
              allowClear
              // onChange={this.onChangeResponsible}
              filterOption={(input, option) =>
                option.props.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toString().toLowerCase()) >= 0
              }
            >
              {technicians
                ? technicians.map((d) => (
                    <Option key={d.value} value={d.value}>
                      {d.text}
                    </Option>
                  ))
                : null}
            </Select>
          </Form.Item>
          <Form.Item
            label="ช่าง"
            {...formItemLayout}
            name="technicians"
            rules={[{ required: false, message: 'เลือกช่าง' }]}
          >
            <Select
              mode="multiple"
              placeholder="--เลือกช่าง--"
              filterOption={(input, option) =>
                option.props.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toString().toLowerCase()) >= 0
              }
              showSearch
              allowClear
            >
              {technicians
                ? technicians.map((d) => (
                    <Option key={d.value} value={d.value}>
                      {d.text}
                    </Option>
                  ))
                : null}
            </Select>
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="ช่าง/ผู้รับเหมา (อื่นๆ)"
            name="technician_name_other"
            rules={[{ required: false, message: 'ช่าง/ผู้รับเหมา (อื่นๆ)' }]}
          >
            <Input
              placeholder="ช่าง/ผู้รับเหมา (อื่นๆ)"
              style={{
                width: '100%',
              }}
              type="text"
            />
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            name="job_status"
            rules={[{ required: true, message: 'เลือกสถานะ' }]}
            noStyle
          >
            <Input type="hidden" />
          </Form.Item>
          <Form.Item
            label="สถานะงาน"
            {...formItemLayout}
            rules={[{ required: true, message: 'เลือกสถานะ' }]}
          >
            <Select
              autoComplete="off"
              placeholder="--เลือกสถานะ--"
              filterOption={false}
              showSearch
              disabled
            >
              {listJobStatus
                ? listJobStatus.map((d) => (
                    <Option key={d.value} value={d.value}>
                      {d.text}
                    </Option>
                  ))
                : null}
            </Select>
          </Form.Item>
        </Form>
      ) : null}
    </Modal>
  )
}
